<template>
  <div
    class="preview"
    :class="isSelected ? 'selectedPreview' : ''"
    @click="select"
    :disabled="isSelected"
  >
    <div class="details">
      <div class="core-details">
        <div class="name"></div>
        <div class="date">{{ startDate }}</div>
        <div class="hour">{{ startHour }}</div>
        <div
          class="verificationStatus"
          :class="
            session.UIDs && session.UIDs.length && session.UIDs.length == 2
              ? 'verified'
              : 'unverified'
          "
        >
          {{
            session.UIDs && session.UIDs.length && session.UIDs.length == 2
              ? "Matched"
              : "Unmatched"
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  name: "PastSessionPreview",
  props: {
    session: Object,
    isSelected: Boolean,
  },
  methods: {
    select() {
      this.$emit("select", this.session);
    },
  },
  computed: {
    startDate() {
      return format(new Date(this.session.dateTime), `MMMM d`);
    },
    startHour() {
      return format(new Date(this.session.dateTime), `HH:mm`);
    },
  },
};
</script>